/**
 * InfoModalControls - Modal de información científica: abrir/cerrar, listeners (botón cerrar,
 * click fuera, pestañas, tecla ESC) y cambio de pestañas.
 *
 * Extraído de UIController para reducir su tamaño. Solo depende del DOM.
 */
export class InfoModalControls {
    constructor() {
        this.modalListenersSetup = false;
    }

    /**
     * Show scientific information modal
     */
    showScientificInfo() {
        console.log('Opening scientific info modal...');
        const modal = document.getElementById('scientific-info-modal');
        if (modal) {
            modal.classList.remove('hidden');
            this.setupModalEventListeners();
            console.log('Scientific info modal opened successfully');
        } else {
            console.error('Scientific info modal not found in DOM');
        }
    }

    /**
     * Hide scientific information modal
     */
    hideScientificInfo() {
        const modal = document.getElementById('scientific-info-modal');
        if (modal) {
            modal.classList.add('hidden');
        }
    }

    /**
     * Setup event listeners for the modal
     */
    setupModalEventListeners() {
        // Avoid setting up listeners multiple times
        if (this.modalListenersSetup) return;
        this.modalListenersSetup = true;

        // Close button
        const closeBtn = document.getElementById('close-modal-btn');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => this.hideScientificInfo());
            console.log('Modal close button listener configured');
        }

        // Click outside modal to close
        const modal = document.getElementById('scientific-info-modal');
        modal?.addEventListener('click', (e) => {
            if (e.target === modal) {
                this.hideScientificInfo();
            }
        });

        // Tab switching
        const tabButtons = document.querySelectorAll('.tab-button');
        tabButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const tabId = button.getAttribute('data-tab');
                this.switchTab(tabId);
            });
        });

        // ESC key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.hideScientificInfo();
            }
        });
    }

    /**
     * Switch between modal tabs
     * @param {string} tabId - ID of the tab to show
     */
    switchTab(tabId) {
        // Hide all tab contents
        const tabContents = document.querySelectorAll('.tab-content');
        tabContents.forEach((content) => {
            content.classList.remove('active');
        });

        // Remove active class from all tab buttons
        const tabButtons = document.querySelectorAll('.tab-button');
        tabButtons.forEach((button) => {
            button.classList.remove('active');
        });

        // Show selected tab content
        const selectedTab = document.getElementById(`${tabId}-tab`);
        if (selectedTab) {
            selectedTab.classList.add('active');
        }

        // Activate selected tab button
        const selectedButton = document.querySelector(`[data-tab="${tabId}"]`);
        if (selectedButton) {
            selectedButton.classList.add('active');
        }
    }
}
